angular.module('e360')
   .directive('cityLookup', cityLookupDirective);

function cityLookupDirective() {
   return {
      restrict: 'A',
      scope: {
         cityLookupCountry: '=',
         onPickPlace: '&'
      },
      link: cityLookupDirectiveLink
   };

   function cityLookupDirectiveLink(scope, element, attrs) {
      var input = element[0];

      var autocomplete = new google.maps.places.Autocomplete(input, {
         types: ['(cities)'],
         componentRestrictions: {country: 'US'}
      });

      autocomplete.addListener('place_changed', onPlaceChanged);

      scope.$watch('cityLookupCountry', countryChanged);

      function onPlaceChanged() {
         var place = autocomplete.getPlace();

         // Autocomplete will set input field to "city, state, country"
         // we just want the city name in the field on place select
         element.val(place.name);

         // notify place change inside angular digest loop
         scope.$apply(function() {
            notifyPlaceChange(place);
         });
      }

      function notifyPlaceChange(place) {
         if (!place.geometry) {
            return;
         }
         
         var result = { };

         _.each(place.address_components, function(addrComp) {
            if (_.contains(addrComp.types, 'locality')) {
               result.city = addrComp.long_name;
            } else if (_.contains(addrComp.types, 'administrative_area_level_1')) {
               result.stateCode = addrComp.short_name;
            } else if (_.contains(addrComp.types, 'country')) {
               result.countryCode = addrComp.short_name;
            }
         });

         if (scope.onPickPlace) {
            scope.onPickPlace({$place: result});
         }
      }

      function countryChanged(newValue, oldValue) {
         if (newValue) {
            autocomplete.setComponentRestrictions({
               country: newValue
            });
         }
      }
   }
}
